import React, { useState, useEffect } from 'react';
import HomePage from './pages/HomePage';
import './index.css';
import './styles/global.css';
  
const App: React.FC = () => {
  const [theme, setTheme] = useState<string>(
    localStorage.getItem('theme') || 'light'
  );
  
  useEffect(() => {
    document.documentElement.classList.toggle('dark', theme === 'dark');
    localStorage.setItem('theme', theme);
  }, [theme]);
  
  const toggleTheme = () => {
    setTheme((prevTheme) => (prevTheme === 'light' ? 'dark' : 'light'));
  };
  
  return (
    <div className="min-h-screen flex flex-col bg-[#FAF7F2] dark:bg-[#121418] text-gray-900 dark:text-gray-100 transition-colors duration-300">
      <header className="sticky top-0 z-50 bg-[#FAF7F2]/90 dark:bg-[#121418]/90 backdrop-blur-md border-b border-orange-100/60 dark:border-gray-800 transition-colors duration-300">
        <div className="max-w-[1520px] mx-auto px-4 sm:px-6 lg:px-8 py-3 flex justify-between items-center">
          {/* Logo & Title */}
          <div className="flex items-center space-x-3.5">
            <div className="bg-gradient-to-br from-orange-500 to-orange-600 text-white font-black text-lg w-10 h-10 rounded-xl shadow-sm flex items-center justify-center flex-shrink-0 tracking-tight">
              GB
            </div>
            <div>
              <h1 className="text-base sm:text-lg font-bold text-gray-900 dark:text-white leading-tight">
                Gujarati's Bangalore Directory
              </h1>
              <p className="text-xs text-gray-500 dark:text-gray-400 leading-tight hidden sm:block">
                By Gujaratis, For the Community
              </p>
            </div>
          </div>

          {/* Nav Items */}
          <div className="flex items-center space-x-3">
            <div className="flex items-center gap-1.5 px-3.5 py-1.5 rounded-full bg-orange-100/80 dark:bg-orange-900/30 text-orange-800 dark:text-orange-300 font-semibold text-xs sm:text-sm border border-orange-200/50 dark:border-orange-800/50">
              <svg className="w-4 h-4 text-orange-600 dark:text-orange-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z" />
              </svg>
              <span>Home</span>
            </div>

            <button
              onClick={toggleTheme}
              aria-label="Toggle theme"
              className="w-9 h-9 rounded-full bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 shadow-sm flex items-center justify-center text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-orange-500"
            >
              {theme === 'light' ? (
                <svg className="w-4 h-4 text-gray-700" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z" />
                </svg>
              ) : (
                <svg className="w-4 h-4 text-amber-400" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z" clipRule="evenodd" />
                </svg>
              )}
            </button>
          </div>
        </div>
      </header>

      <main className="flex-grow">
        <HomePage />
      </main>

      <footer className="bg-white/60 dark:bg-gray-900/60 border-t border-orange-100/60 dark:border-gray-800 text-center py-4 text-xs text-gray-500 dark:text-gray-400">
        <div className="max-w-[1520px] mx-auto px-4">
          <p>© {new Date().getFullYear()} Gujarati's Bangalore Directory • Curated for the community</p>
        </div>
      </footer>
    </div>
  );
};

export default App;